<template>
  <div id="login" class="body-container" v-title :data-title="$t('titleText.account_CZUR')">
    <basicheader :login="false"></basicheader>
    <router-view :lang="lang"></router-view>
<!--    <login @showCountry="showCountryAction" v-show="!showCountry"></login>-->
<!--    <Country v-if="showCountry" :lang="lang"></Country>-->
    <czurfooter  @changeAppLocale="changeAppLocale"></czurfooter>
    <div v-if="lang === 'en' && showCookie">
      <mobileCookie v-if="isPhone && lang"></mobileCookie>
      <cookie v-else></cookie>
    </div>
  </div>
</template>

<script>
import cookie from '../cookie/cookie.vue'
import mobileCookie from '../mobileCookie/mobileCookie.vue'
import login from 'components/login/login'
import czurfooter from 'components/footer/footer'
import Config from 'common/script/config.js'
import basicheader from 'components/header/header'
import Country from 'components/country/country.vue'
export default {
  name: 'index',
  data () {
    return {
      lang: '',
      showCountry: false,
      isPhone: false,
      showCookie: false
    }
  },
  components: {
    login,
    czurfooter,
    basicheader,
    Country,
    cookie,
    mobileCookie
  },
  created () {
    if (window.screen.availWidth < 1000) {
      this.isPhone = true
    }
    this.showCookie = Config.env === 'prod_na' || Config.env === 'test_na'
  },
   methods: {
    changeLanguage (lang) {
      this.$i18n.locale = lang
      this.lang = lang
      Config.cookieSet('lang', lang)
    },
    changeAppLocale (locale) {
      this.changeLanguage(locale)
    },
    showCountryAction () {
      this.showCountry = true
    }
  },
  mounted () {
    this.changeLanguage(this.$i18n.locale)
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
</style>



// WEBPACK FOOTER //
// index.vue?c43c6070